export function convertCSV(csv) {
  const lines = csv.split('\n')
  const result = []
  const headers = lines[0].split(',')

  for (let i = 1; i < lines.length; i++) {
    if (!lines[i]) continue
    const obj = {}
    const currentline = lines[i].split(',')

    for (let j = 0; j < headers.length; j++) {
      obj[headers[j].trim()] = currentline[j].replaceAll('\n', '').trim()
    }
    result.push(obj)
  }
  return result
}
